export const OutpatientClinic = {
    Tasks: '/api/outpatientClinic/tasks',
    TasksMetadata: '/api/outpatientClinic/tasks/metadata',
    TasksTypes: '/api/outpatientClinic/tasks/types',
    // Add other outpatient clinic related endpoints here
} as const;
